import {
  BRANCH_MODAL,
  CLEAR_BRANCHES,
  GET_BRANCHES,
  GET_BRANCH_NAMES,
} from 'redux/actions/types';

const initialState = {
  isLoading: true,
  modalData: {},
  branches: [],
};

const branches = (state = initialState, { type, data }) => {
  switch (type) {
    case GET_BRANCHES:
      return {
        ...state,
        branches: data.branches,
        isLoading: false,
      };
    case GET_BRANCH_NAMES:
      return {
        ...state,
        branchNames: data.branches,
      };
    case CLEAR_BRANCHES:
      return initialState;

    case BRANCH_MODAL:
      return {
        ...state,
        modalData: data,
      };

    default:
      return state;
  }
};

export default branches;
